import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import noop from 'lodash/noop';
import map from 'lodash/map';

import styles from './CategoryView.css';
import Category from './Category.js';

class CategoryView extends React.Component {
  constructor(props) {
    super(props);

    this.selectListItem = this.selectListItem.bind(this);
    this.highlightListItem = this.highlightListItem.bind(this);
    this.initCategoryNavigation = this.initCategoryNavigation.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      selectedListItem: null
    };
  }

  selectListItem(key, item, afterListItemSelect = noop) {
    this.setState({
      selectedListItem: key
    }, afterListItemSelect);
    this.props.onSelection(item);
  }

  handleScroll(element, index) {
    const scrollView = ReactDOM.findDOMNode(this).parentElement;
    const currentlySelectedKey = this.state.selectedListItem;
    const categoryName = this.props.categories[0].name;
    const currentlySelectedIndex = currentlySelectedKey ? currentlySelectedKey.replace(categoryName, '') : -1;
    const navigatingDown = parseInt(currentlySelectedIndex, 10) < index;
    const navigatingUp = parseInt(currentlySelectedIndex, 10) > index;
    const preventScrollDown = (element.offsetTop + element.clientHeight) < scrollView.clientHeight;
    const preventScrollUp = element.offsetTop > scrollView.clientHeight;
    const scrollDownPrevent = () => {
      // Avoid to trigger the listener when custom scroll
      scrollView.removeEventListener('scroll', scrollDownPrevent);
      scrollView.scrollTo(0, 0);
    };
    const scrollUpPrevent = () => {
      // Avoid to trigger the listener when custom scroll
      scrollView.removeEventListener('scroll', scrollUpPrevent);
      let position = scrollView.offsetTop;
      if (position ===0){
        position = element.offsetTop;
      }
      scrollView.scrollTo(0, position);
    };
    element.focus();
    if (navigatingDown){
      if (preventScrollDown) {
        scrollView.addEventListener('scroll', scrollDownPrevent);
      }
    }
    if (navigatingUp) {
      if (preventScrollUp) {
        scrollView.addEventListener('scroll', scrollUpPrevent);
      }

    }
  }

  highlightListItem(key, index) {
    if (index !== -1) {
      let categoryItemDOMNode = ReactDOM.findDOMNode(this).getElementsByTagName('li')[index];
      categoryItemDOMNode = categoryItemDOMNode.getElementsByTagName('div')[0];
      this.handleScroll(categoryItemDOMNode, index);
    }
    this.setState({
      selectedListItem: key
    });
  }

  initCategoryNavigation() {
    const firstItemKey = this.props.categories[0].name + '0';
    this.highlightListItem(firstItemKey,0);
  }

  render() {
    const {categories, increment, decrement, handleSuccess, focusSearchInput} = this.props;
    const {selectedListItem} = this.state;

    const hasMoreThanOneCategory = categories.length > 1;
    const viewClass = hasMoreThanOneCategory ? styles.condensedCategoryView : styles.categoryView;

    return (
      <div className={viewClass}>
        {map(categories, (category) => (
          <Category
            key={category.name}
            showHeader={hasMoreThanOneCategory}
            showSmallCountControls={hasMoreThanOneCategory}
            showDescriptions={!hasMoreThanOneCategory}
            categoryData={category}
            increment={increment}
            decrement={decrement}
            selectListItem={this.selectListItem}
            highlightListItem={this.highlightListItem}
            selectedListItem={selectedListItem}
            handleSuccess={handleSuccess}
            focusSearchInput={focusSearchInput}
          />
        ))}
      </div>
    );
  }
}

CategoryView.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  increment: PropTypes.func,
  decrement: PropTypes.func,
  onSelection: PropTypes.func,
  handleSuccess: PropTypes.func,
  focusSearchInput: PropTypes.func
};

CategoryView.defaultProps = {
  onSelection: noop,
  handleSuccess: noop,
  focusSearchInput: noop
};

export default CategoryView;
